import { render, staticRenderFns } from "./InspectionReport.vue?vue&type=template&id=0b49f55e&scoped=true&"
import script from "./InspectionReport.vue?vue&type=script&lang=js&"
export * from "./InspectionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b49f55e",
  null
  
)

export default component.exports